module.exports = __webpack_public_path__ + "img/charging-hub-in-progress-semipublic.fdcaa599.svg";